export function formatTime(minutes) {
  let hours = Math.floor(minutes / 60);
  let mins = minutes % 60;

  let hoursStr = hours.toString().padStart(2, '0');
  let minsStr = mins.toString().padStart(2, '0');

  return `${hoursStr}:${minsStr}`;
}
export function formatPeriod(period){
  const periods = {"indefinite": "Indefinido",
   "temporary": "Temporal",
   "1-6months": "1-6 meses",
  "6months": "6 meses",
  "6-12months": "6-12 meses",
  "more6months": "> 6 meses"}
  return periods[period]
}
export function formatSize(size){
  if (size == "small"){
    return "Pequeño"
  }
  if (size == "medium"){
    return "Mediano"
  }
  if (size == "large") {return "Grande"}
  return null
}

export function getImageUrl(img){
return "https://pub-5115ef50b92446fe883b768d3193fbcc.r2.dev/" + img + ".png"
}

export function formatTags(tag){
  const tags = {
        EASY_MANEUVER: "Fácil maniobra",
        AUTOMATIC_DOOR: "Puerta automática",
        MOBILE_OPENING: "Apertura con móvil",
        FREIGHT_ELEVATOR: "Montacargas",
        PEDESTRIAN_ELEVATOR: "Ascensor peatonal",
        SECURITY_CAMERAS: "Cámaras de seguridad",
        SECURITY_PERSONNEL: "Personal de seguridad",
        HOMYHUB: "HOMYHUB",
    };

  return tags[tag]
}
